import { render, staticRenderFns } from "./GuardianField.vue?vue&type=template&id=39e94ce6&scoped=true"
import script from "./GuardianField.vue?vue&type=script&lang=js"
export * from "./GuardianField.vue?vue&type=script&lang=js"
import style0 from "./GuardianField.vue?vue&type=style&index=0&id=39e94ce6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e94ce6",
  null
  
)

export default component.exports